import React from 'react'

export const getBlankLinkComponent = (href: string) => (
  <a target={'_blank'} rel={'noreferrer'} href={href} className={'primary-link'} />
)
